/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-01 14:40:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 16:35:04
 */
import ColumnTypes from '@/utils/ColumnTypes';

const descInfo = {
	key: 'descInfo',
	label: '达人信息',
	type: () => import('./descInfo.vue'),
	width: '215',
};
const cooperate_count = {
	key: 'cooperate_count',
	label: '关联合作进度数',
	type: 'rdText',
	minWidth: '120',
};
const sample_count = {
	key: 'sample_count',
	label: '关联样品订单数',
	type: 'rdText',
	minWidth: '120',
};
const cooperate_status_name = {
	key: 'cooperate_status_name',
	label: '跟进状态',
	type: 'rdText',
	minWidth: '90',
};
const authority_id = {
	key: 'authority_id',
	label: '机构ID',
	type: 'rdText',
	minWidth: '110',
};
const shop_name = {
	key: 'shop_name',
	label: '店铺名称',
	type: 'rdText',
	width: '100',
};
const status = {
	key: 'status',
	label: '交接进度',
	type: () => import('./status.vue'),
	width: '110',
};
export default {
	descInfo,
	cooperate_count,
	sample_count,
	cooperate_status_name,
	authority_id,
	shop_name,
	status,
};
